module.exports = __webpack_public_path__ + "static/media/yoyow.9196885c.svg";